import { render, staticRenderFns } from "./auto-parents.vue?vue&type=template&id=546c68e8&"
import script from "./auto-parents.vue?vue&type=script&lang=js&"
export * from "./auto-parents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports